// components/registration/PublicLimitedCompanyRegistration.jsx
import React from "react";

export default function PublicLimitedCompanyRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Public Limited Company Registration.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Public Limited Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Public Limited Company Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports Public Limited Company Registration
            with complete regulatory compliance, ideal for businesses planning
            large‑scale operations and public investment.[web:42]
          </p>
          <p className="text-gray-700">
            From structuring share capital and board composition to
            documentation for listing readiness and regulatory approvals, the
            incorporation process is managed professionally so that your
            organization is prepared for future fundraising and expansion.[web:41][web:42]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Boardroom meeting for public limited company registration"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Public Limited Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists in compiling and filing all documents
              required for Public Limited Company Registration, reducing the
              risk of queries and resubmissions during scrutiny.[web:41][web:42]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN and address proof of all directors</li>
                <li>Identity proof of shareholders</li>
                <li>Registered office address proof</li>
                <li>Digital Signature Certificate (DSC) of proposed directors</li>
                <li>Director Identification Number (DIN) for all directors</li>
                <li>Photographs of directors and key shareholders</li>
                <li>
                  Foundational documents such as Memorandum and Articles of
                  Association, as applicable.[web:41][web:42]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks combines strong corporate law expertise with
              practical experience in handling complex public company
              incorporations and ongoing compliance.[web:41][web:42]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Strong Corporate Law Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Deep understanding of public company requirements, including
                  board composition, share capital structure, and disclosure
                  standards required for public participation.[web:41][web:42]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Transparent Compliance Management
                </h3>
                <p className="text-gray-700 text-sm">
                  Structured processes, clear timelines, and transparent
                  communication at every stage of incorporation and post‑
                  incorporation compliance.[web:41][web:42]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Incorporation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End‑to‑end assistance from name approval and digital
                  signatures to filing incorporation forms and obtaining the
                  Certificate of Incorporation, tailored for large‑scale
                  companies.[web:41][web:42]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
